<div class="bg-light min-vh-100 d-flex flex-row align-items-center" *transloco="let t">
    <c-container>
      <c-row class="justify-content-center">
        <c-col md="6">
          <c-card-group>
            <c-card class="p-4">
              <c-card-body>
                <form [formGroup]="passwordForm" cForm (ngSubmit)="submitPassword()">
                  <div class="text-center">
                    <img alt="Logo" src="../../../assets/images/newlogo.png"  />
                  </div>
                  <h1>{{ t('Login to the Dashboard') }}</h1>
                  <p class="text-medium-emphasis">{{ t('Reset Your Password') }}</p>
                  <c-input-group class="mb-4">
                    <span cInputGroupText>
                      <svg cIcon name="cilLockLocked"></svg>
                    </span>
                    <input
                      autoComplete="current-password"
                      cFormControl
                      [formControlName]="'password'"
                      placeholder="{{ t('Password') }}"
                      type="password"
                      [ngClass]="{ 'border-danger': submitted && f['password'].errors }"
                    />
                  <div *ngIf="submitted && f['password'].errors" class="invalid-feedback">
                      {{ t('Password should be at least 8 characters in length and should include at least one upper case letter, one number, and one special character.') }}
                  </div>
                  </c-input-group>

                  <div role="alert" *ngIf="okService.alert.message" [className]="'alert  alert-dismissible fade show alert-' + okService.alert.type">
                    {{okService.alert.message}}
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" (click)="okService.clearAlert()"></button>
                  </div>

                  <c-row>
                    <c-col xs="6">
                      <button cButton class="px-4 text-white btn-info" type="submit">
                        {{ t('Reset Your Password') }}
                      </button>
                    </c-col>
                    <c-col class="text-right" xs="6">
                      <button cButton class="px-0" color="link"  routerLink="/login">
                        {{ t('Back to Login') }}
                      </button>
                    </c-col>
                  </c-row>
                </form>
              </c-card-body>
            </c-card>
          </c-card-group>
        </c-col>
      </c-row>
    </c-container>
  </div>
